<template>
    <q-dialog v-model="modal" persistent>
        <q-card>
            <q-card-section class="row items-center">
                <span class="q-ml-sm">{{ message }}</span>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn class="bg-negative" flat label="Нет" color="white" v-close-popup />
                <q-btn class="bg-primary" flat label="Да" color="white" v-close-popup @click="confirm" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
    export default {
        name: "Confirm",
        props: {
            message: String
        },
        data: function () {
            return {
                modal: false
            }
        },
        methods: {
            show () {
                this.$set(this, 'modal', true);
            },
            confirm () {
                this.$emit('confirm');
            }
        }
    }
</script>